import PropTypes from 'prop-types';
import React from 'react';
import {CircularProgress, Stack, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

const Loading = ({
  message,
  progressSize = 50,
  subheaderTypographyProps,
  suffix = '',
  titleTypographyProps,
  ...props
}) => {
  const {t} = useTranslation();

  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      flexShrink={0}
      margin="auto"
      textAlign="center"
      data-testid="loading-message"
      height="100%"
      {...props}
    >
      <CircularProgress
        color="primary"
        size={progressSize}
        sx={{marginBottom: 2}}
      />
      <Typography
        variant="h5"
        color="text.secondary"
        gutterBottom
        {...titleTypographyProps}
      >
        {message ? message : t('loadingMessage.titleLoading', {item: suffix})}
      </Typography>
      <Typography
        variant="h6"
        color="text.secondary"
        {...subheaderTypographyProps}
      >
        {t('loadingMessage.messageLoading')}
      </Typography>
    </Stack>
  );
};

Loading.propTypes = {
  message: PropTypes.string,
  progressSize: PropTypes.number,
  suffix: PropTypes.string,
  titleTypographyProps: PropTypes.object,
  subheaderTypographyProps: PropTypes.object,
};

export default Loading;
